const regularPlans = [
    {
        "uuid": "1",
        "createdOn": "2021-10-01T08:20:10.000Z",
        "appNo": "A21100106",
        "appType": "followUp",
        "activity": "S10",
        "customerNo": "0001",
        "customerName": "源天然股份有限公司",
        "assessmentPlace": "台東廠",
        "remainingDays": 3,
        "productLineCount":2,
        "productCount":10,
        "inspectionManDay":1.5,
        "leezenProductCount":3,
        "semiProductCount":2,
        "certificateExpiredDate": "2022-08-05T00:00:00.000Z",
        "contractType":"two-party",
        "existCustomers":["leezen"],
        "inspectionYear": 2022,
        "season": "Q2",
        "chargeCertificateMarkFee": "台東廠",
        "totalProductCount": 10,
        "chargeItems":[
            {
                "item":"management",
                "amountDefault":1000,
                "amountModified":1000
            },
            {
                "item":"onSiteAudit",
                "amountDefault":2000,
                "amountModified":2000
            },
            {
                "item":"certificate",
                "amountDefault":1500,
                "amountModified":1500
            },
            {
                "item":"labelAnnual",
                "amountDefault":2100,
                "amountModified":2100
            }
        ]
    },
    {
        "uuid": "2",
        "createdOn": "2021-10-01T08:20:10.000Z",
        "appNo": "A21100105",
        "appType": "followUp",
        "activity": "S10",
        "customerNo": "0001",
        "customerName": "源天然股份有限公司",
        "assessmentPlace": "屏東廠",
        "remainingDays": 3,
        "productLineCount":2,
        "productCount":10,
        "inspectionManDay":1.5,
        "leezenProductCount":3,
        "semiProductCount":2,
        "certificateExpiredDate": "2022-08-05T00:00:00.000Z",
        "contractType":"two-party",
        "existCustomers":["leezen"],
        "inspectionYear": 2022,
        "season": "Q2",
        "chargeCertificateMarkFee": "台東廠",
        "totalProductCount": 10,
        "chargeItems":[
            {
                "item":"management",
                "amountDefault":1000,
                "amountModified":1000
            },
            {
                "item":"onSiteAudit",
                "amountDefault":2000,
                "amountModified":2000
            },
            {
                "item":"certificate",
                "amountDefault":1500,
                "amountModified":1500
            },
            {
                "item":"labelAnnual",
                "amountDefault":2100,
                "amountModified":2100
            }
        ]
    },
    {
        "uuid": "3",
        "createdOn": "2021-10-01T08:20:10.000Z",
        "appNo": "A21100104",
        "appType": "renewal",
        "activity": "S10",
        "customerNo": "0002",
        "customerName": "豆之家股份有限公司",
        "assessmentPlace": "台東廠",
        "remainingDays": 3,
        "renewalApplicationDeadline": "2021-10-31T08:20:10.000Z",
        "productLineCount":2,
        "productCount":10,
        "inspectionManDay":1.5,
        "leezenProductCount":3,
        "semiProductCount":2,
        "certificateExpiredDate": "2022-08-05T00:00:00.000Z",
        "contractType":"two-party",
        "existCustomers":["leezen"],
        "inspectionYear": 2022,
        "season": "Q2",
        "chargeCertificateMarkFee": "台東廠",
        "totalProductCount": 10,
        "chargeItems":[
            {
                "item":"management",
                "amountDefault":1000,
                "amountModified":1000
            },
            {
                "item":"onSiteAudit",
                "amountDefault":2000,
                "amountModified":2000
            },
            {
                "item":"certificate",
                "amountDefault":1500,
                "amountModified":1500
            },
            {
                "item":"labelAnnual",
                "amountDefault":2100,
                "amountModified":2100
            }
        ]
    },
    {
        "uuid": "4",
        "createdOn": "2021-10-02T08:20:10.000Z",
        "appNo": "A21100103",
        "appType": "followUp",
        "activity": "S20",
        "customerNo": "0003",
        "customerName": "黑松股份有限公司",
        "assessmentPlace": "台南廠",
        "remainingDays": 2,
        "productLineCount":2,
        "productCount":10,
        "inspectionManDay":1.5,
        "leezenProductCount":3,
        "semiProductCount":2,
        "certificateExpiredDate": "2022-08-05T00:00:00.000Z",
        "contractType":"two-party",
        "paymentUnit":"customer",
        "existCustomers":["leezen"],
        "inspectionYear": 2022,
        "season": "Q2",
        "chargeCertificateMarkFee": "台東廠",
        "totalProductCount": 10,
        "chargeItems":[
            {
                "item":"management",
                "amountDefault":1000,
                "amountModified":1000,
                "adjustment": "調整說明1"
            },
            {
                "item":"onSiteAudit",
                "amountDefault":2000,
                "amountModified":2100,
                "adjustment": "調整說明2"
            },
            {
                "item":"certificate",
                "amountDefault":1500,
                "amountModified":1500,
                "adjustment": "調整說明3"
            },
            {
                "item":"labelAnnual",
                "amountDefault":2100,
                "amountModified":2100,
                "adjustment": "調整說明4"
            }
        ]
    },
    {
        "uuid": "5",
        "createdOn": "2021-10-03T08:20:10.000Z",
        "appNo": "A21100102",
        "appType": "followUp",
        "activity": "S30",
        "customerNo": "0004",
        "customerName": "中農粉絲有限公司",
        "assessmentPlace": "屏東廠",
        "remainingDays": 1,
        "productLineCount":2,
        "productCount":10,
        "inspectionManDay":1.5,
        "leezenProductCount":3,
        "semiProductCount":2,
        "certificateExpiredDate": "2022-08-05T00:00:00.000Z",
        "contractType":"two-party",
        "paymentUnit":"customer",
        "existCustomers":["leezen"],
        "inspectionYear": 2022,
        "season": "Q2",
        "chargeCertificateMarkFee": "台東廠",
        "totalProductCount": 10,
        "chargeItems":[
            {
                "item":"management",
                "amountDefault":1000,
                "amountModified":1000,
                "adjustment": "調整說明1"
            },
            {
                "item":"onSiteAudit",
                "amountDefault":2000,
                "amountModified":2100,
                "adjustment": "調整說明2"
            },
            {
                "item":"certificate",
                "amountDefault":1500,
                "amountModified":1500,
                "adjustment": "調整說明3"
            },
            {
                "item":"labelAnnual",
                "amountDefault":2100,
                "amountModified":2100,
                "adjustment": "調整說明4"
            }
        ]
    },
    {
        "uuid": "6",
        "createdOn": "2021-10-04T08:20:10.000Z",
        "appNo": "A21100101",
        "appType": "renewal",
        "activity": "S40",
        "customerNo": "0005",
        "customerName": "我的輕食有限公司",
        "assessmentPlace": "高雄廠",
        "remainingDays": -1,
        "renewalApplicationDeadline": "2021-10-31T08:20:10.000Z",
        "productLineCount":2,
        "productCount":10,
        "inspectionManDay":1.5,
        "leezenProductCount":3,
        "semiProductCount":2,
        "certificateExpiredDate": "2022-08-05T00:00:00.000Z",
        "contractType":"two-party",
        "paymentUnit":"customer",
        "existCustomers":["leezen"],
        "inspectionYear": 2022,
        "season": "Q2",
        "chargeCertificateMarkFee": "台東廠",
        "totalProductCount": 10,
        "chargeItems":[
            {
                "item":"management",
                "amountDefault":1000,
                "amountModified":1000
            },
            {
                "item":"onSiteAudit",
                "amountDefault":2000,
                "amountModified":2100
            },
            {
                "item":"certificate",
                "amountDefault":1500,
                "amountModified":1500
            },
            {
                "item":"labelAnnual",
                "amountDefault":2100,
                "amountModified":2100
            }
        ]
    },
]

export default regularPlans;